import React from 'react'
import { Card, CardBody, CardTitle, Row, Col, Label } from "reactstrap"
import { DetalleParametrosPlanificacionHE } from '../TypesParametrosHorasExtras'
import ParametrosHorasPlanificacionRegimen from './ParametrosHorasPlanificacionRegimen'

type PropsCardNroHorasPlanificacion= {
    parametros: DetalleParametrosPlanificacionHE | null | undefined,
}

export default function CardNroHorasPlanificacion(props: PropsCardNroHorasPlanificacion) {
    return (
        <Card>
            <CardTitle className="cardHeaderParametrosHorasPlanificacion" >
                <span className='pl-3'>
                    Número máximo de horas extras para planificación
                    <span className='pl-3'>
                        <i
                            className="fas fa-info-circle"

                        />
                    </span>

                </span>

            </CardTitle>
            <CardBody className="cardBodyNroHorasExtras">
                <Row>
                    <Col xl={6} className={"colParamNroHoras1"}>
                        <ParametrosHorasPlanificacionRegimen
                            idRegimenLaboral={7}
                            nombreRegimen='LOSEP'
                            parametros={props.parametros?.listadoparametroshorasregimen}
                        />

                    </Col>
                    <Col xl={6} className={"colParamNroHoras2"}>
                        <ParametrosHorasPlanificacionRegimen
                            idRegimenLaboral={9}
                            nombreRegimen='CÓDIGO DE TRABAJO'
                            parametros={props.parametros?.listadoparametroshorasregimen}
                        />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
